import classes from "./ActivityEditor.module.css";
import Skeleton, {} from "react-loading-skeleton";
import React, {useEffect, useRef, useState} from "react";

import {ReactComponent as DOCUMENT_ICON} from "../../images/document_purple.svg"
import {ReactComponent as CHAT_ICON} from "../../images/bubble_chat_purple.svg"
import {ReactComponent as QUESTION_MARKER} from "../../images/question_marker_gray.svg";
import {
    ACTIVITY_EDITOR_VIEW,
    ADD_QUESTION_TEXT,
    BUTTON,
    DELETE_BTN,
    DUPLICATE_BTN,
    POINT_TEXT,
    POINTS_TEXT,
    POLL_TYPE,
    QUESTION_TEXT,
    SELECT_QUESTION_TYPE_TEXT,
    TEXTBOX,
    QUESTION_HEADER,
    GRADE_SCHEMA,
    Q_TEXT,
    QUESTION_TYPES,
    CONFIGURATION_TEXT,
    ATTENDANCE,
    POLL_SHARE_MODE, POLL_TEXT, QUESTION_CARDS_CAN_NOT_ACCESS, QUESTION_CARDS_CAN_NOT_ACCESS_ATTENDANCE,
    IMPORT_QUESTIONS_TEXT, IMPORT_QUESTION_TEXT,
} from "../../utils/constants";
import {
    appendQuestion,
    deleteQuestion,
    handleQuestionOrderChange,
    questionCodeToName,
    questionError
} from "../../utils/questionUtils";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {useImageLoaderManager} from "../../hooks/useImageLoaderManager";
import {PollApiCalls} from "../../apis/PollApiCalls";
import { ReactComponent as DeleteIcon } from "../../images/delete.svg";
import { ReactComponent as DuplicateIcon } from "../../images/duplicate.svg";
import { ReactComponent as PlusIcon } from "../../images/plus.svg";
import { ReactComponent as UploadIcon } from "../../images/ClickableImageUploadSmall.svg";
import { ReactComponent as ConfigurationIcon } from "../../images/settings_purple.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {generateUUID, getQuestionWeightage, send2ScreenReader} from "../../utils/helpers";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {Button} from "@base-ui/react/button";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";


export default function ActivityEditorDashboard ({
                                                     editorView,
                                                     setEditorView,
                                                     dataLoading,
                                                     draftActivity = {},
                                                     setQuestions,
                                                     currQueDisplay,
                                                     setCurrQueDisplay,
                                                     questionBankId,
                                                     userSettings,
                                                     hasReleased=false,
}) {
    const {width: windowWidth} = useWindowDimensions();
    const {isLMS, isAPISyncOptionAvailable, getIntegrationType, verifyConfigurationBeforeAddingQuestion} = useSynLMSConfiguration(draftActivity);
    const [randomId, ] = useState(() => generateUUID());
    const { duplicateImagesOfQuestion, duplicateImagesOfQuestionBank} = PollApiCalls();
    const [setPreviousView, ] = useLocalStorageNew("previous_editor_view", "");
    const {pollKey, pollType, gradeSchema, questions=[]} = draftActivity;
    const EXPAND_POINT = 1000;

    const [isExpanded, setIsExpanded] = useState(windowWidth >= EXPAND_POINT);
    const cardRef = useRef();


    const isShareAll = draftActivity.pollType === POLL_TYPE.ATTENDANCE
    || draftActivity.pollShareMode === POLL_SHARE_MODE.SHARE_ALL
    || draftActivity.pollShareMode === POLL_SHARE_MODE.SCHEDULE;

    const {
        checkQueImagesIsLoading,
        setQuestionLoading,
        resetImages,
        setImages
    } = useImageLoaderManager(questions, setQuestions);



    const onClickQuestionTab = (e) => {
        if (!!e.currentTarget && e.currentTarget.className.includes("inactive")) {
            return;
        }

        if (draftActivity.pollType === POLL_TYPE.ATTENDANCE) {
            setEditorView(ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING);
        } else {
            setEditorView(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
        }
    }


    const clickNewQuestion = (e) => {
        e.stopPropagation();
        const newQuestions = appendQuestion(questions);
        setQuestions(newQuestions);
        setCurrQueDisplay(newQuestions.length);
        send2ScreenReader(`New question is added.`);

        setTimeout(() => {
            let list = document.querySelector(`[data-activity-editor-list-dashboard-id='${randomId}']`);
            list?.scroll({top: list.scrollHeight, behavior: "smooth"});
        }, 100);
    };

    const clickDuplicate = async (selectedQuestion, e) => {
        e.stopPropagation();
        const {serialNo} = selectedQuestion;


        const questionsCopy = JSON.parse(JSON.stringify(questions));
        let duplicatedQuestion = JSON.parse(JSON.stringify(selectedQuestion));
        let newQuestions = [];
        for (const q of questionsCopy) {
            if (q.serialNo === serialNo) {
                newQuestions.push({...q, checked: false});
                duplicatedQuestion.serialNo = q.serialNo + 1;
                duplicatedQuestion.checked = true;
                newQuestions.push(duplicatedQuestion);
            } else if (q.serialNo > serialNo) {
                newQuestions.push({ ...q, serialNo: q.serialNo + 1, checked: false });
            } else {
                newQuestions.push({ ...q, checked: false });
            }
        }


        const resourceMapping = setQuestionLoading(duplicatedQuestion);
        setQuestions(newQuestions);
        setCurrQueDisplay(serialNo + 1);

        send2ScreenReader(`Question is duplicated.`);
        if (!resourceMapping || !Object.entries(resourceMapping).length) {
            return;
        }

        //duplicate images of the question
        if (!questionBankId) {
            duplicateImagesOfQuestion(pollKey, selectedQuestion, resourceMapping).then((returnedMapping) => {
                //error
                if (!returnedMapping) {
                    resetImages(Object.values(resourceMapping));
                    return;
                }

                //set imageURL
                setImages(returnedMapping);
            });
        } else {
            duplicateImagesOfQuestionBank(questionBankId, resourceMapping).then((returnedMapping) => {
                //error
                if (!returnedMapping) {
                    resetImages(Object.values(resourceMapping));
                    return;
                }

                //set imageURL
                setImages(returnedMapping);
            });
        }
    };

    const clickDelete = (selectedQuestion, e) => {
        e.stopPropagation();
        const {serialNo} = selectedQuestion;
        const newQuestions = deleteQuestion(selectedQuestion, questions);
        setCurrQueDisplay(serialNo === 1 ? 1 : serialNo - 1);
        setQuestions(newQuestions.length === 0 ? [{serialNo: 1}] : newQuestions);
        send2ScreenReader(`Question is deleted.`);
    };

    const getQuestionTabTooltipText = () => {
        if (!!questionBankId) {
            return QUESTION_HEADER;
        }

        if (isShareAll && hasReleased) {
            return pollType === ATTENDANCE
                ? QUESTION_CARDS_CAN_NOT_ACCESS_ATTENDANCE
                : QUESTION_CARDS_CAN_NOT_ACCESS;
        }

        if (pollType === POLL_TYPE.MERGED_POLL && !gradeSchema) {

            return (
                isLMS()
                    ? "Select a grade option and fill out the required fields."
                    : "Select a grade option."
            );
        }

        let errorText = verifyConfigurationBeforeAddingQuestion(draftActivity);
        if (!!errorText) {
            return pollType === POLL_TYPE.ATTENDANCE
                ? (
                    isAPISyncOptionAvailable()
                        ? "Select a sync option and fill out the required fields."
                        : "Select a sync option"
                )
                : (
                    isLMS()
                        ? "Select a grade option and fill out the required fields."
                        : "Select a grade option."
                )
        }


        if (!isExpanded) {
            return QUESTION_HEADER;
        }

        return "";


        // disabled={!!gradeSchema && isExpanded && !(isShareAll && hasReleased)}


        // text={!gradeSchema
        //         ? CHOOSE_GRADE_OPTION_BEFORE_ADD_QUESTION_TEXT
        //         : (isShareAll && hasReleased
        //                 ? "Questions cannot be accessed after a poll is released."
        //                 : QUESTION_HEADER
        //         )
        // }
    }


    useEffect(() => {
        setIsExpanded(windowWidth >= EXPAND_POINT);
    }, [windowWidth]);

    const renderQuestionCard = (draggableProvided, question) => {
        const {serialNo, questionType, shareCount} = question;
        let {quesError} = questionError(question, POLL_TYPE.MERGED_POLL, draftActivity.gradeSchema);
        let cardClassesArr = [classes.dashboardQuestionCard];
        if (serialNo === currQueDisplay) {
            cardClassesArr.push(classes.active);
        }

        if (!isExpanded) {
            cardClassesArr.push(classes.collapsed);
        }

        if (!!shareCount) {
            cardClassesArr.push(classes.inactive);
        }

        const onClickCard = () => {
            setCurrQueDisplay(serialNo);
            setEditorView(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
        }



        if (!isExpanded) {
            const queType =  QUESTION_TYPES[questionType] ?  QUESTION_TYPES[questionType] : {};
            const {iconGrey: Icon=QUESTION_MARKER, description=SELECT_QUESTION_TYPE_TEXT} = queType;
            return (
                <YuJaTooltip
                    placement={"right"}
                    text={!!shareCount
                        ? "A question cannot be edited after it is released."
                        : (
                            <>
                                <div style={{marginBottom: 3}}>{QUESTION_TEXT} {serialNo}</div>
                                <div>{description}</div>
                            </>
                        )
                    }
                >
                    <div
                        tabIndex={0}
                        className={cardClassesArr.join(" ")}
                        {...draggableProvided.draggableProps}
                        {...draggableProvided.dragHandleProps}
                        ref={draggableProvided.innerRef}
                        aria-label={QUESTION_TEXT + serialNo}
                        // onMouseDown={() => document.getElementById("dummyInputBox").focus()}
                        onClick={() => {
                            if (!shareCount) {
                                onClickCard();
                            }
                        }}
                    >
                        <div style={{display: "flex", alignItems: "center", gap: 7, flex: 1, minWidth: 0}}>
                        <span className={classes.questionIcon}>
                             <Icon style={{width: 16, height: 16}}/>
                        </span>


                            <span style={{
                                fontWeight: "600",
                                flex: 1,
                                minWidth: 0,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}>
                            {Q_TEXT}{serialNo}
                        </span>
                        </div>
                    </div>
                </YuJaTooltip>
            );
        }

        return (
            <YuJaTooltip
                placement={"right"}
                text={"A question cannot be edited after it is released."}
                disabled={!shareCount}
            >
                <div
                    className={cardClassesArr.join(" ")}
                    {...draggableProvided.draggableProps}
                    {...draggableProvided.dragHandleProps}
                    ref={draggableProvided.innerRef}
                    aria-label={QUESTION_TEXT + serialNo}
                    // onMouseDown={() => document.getElementById("dummyInputBox").focus()}
                    onClick={() => {
                        if (!shareCount) {
                            onClickCard();
                        }
                    }}
                >
                    <div style={{display: "flex", alignItems: "center"}}>
                        <span
                            className={classes.questionNo}
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                wordBreak: "keep-all",
                            }}
                        >
                            {QUESTION_TEXT} {serialNo}
                        </span>
                        <span style={{flex: 1}}/>
                        {!!getQuestionWeightage(question) && gradeSchema !== GRADE_SCHEMA.UNGRADED.key &&
                            <span>
                                {getQuestionWeightage(question)} {getQuestionWeightage(question) > 1 ? POINTS_TEXT.toLowerCase() : POINT_TEXT.toLowerCase()}
                            </span>
                        }
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        <span className={classes.questionType}>
                            {!!questionType
                                ? questionCodeToName(questionType)
                                : SELECT_QUESTION_TYPE_TEXT
                            }
                        </span>
                        <span style={{flex: 1}}/>
                        <div className={classes.iconBar}>
                            {!hasReleased && !checkQueImagesIsLoading(question) &&
                                <>
                                    <Button
                                        aria-label={DUPLICATE_BTN.slice(0, -1)}
                                        title={DUPLICATE_BTN.slice(0, -1)}
                                        onClick={(e) => clickDuplicate(question, e)}
                                    >
                                        <DuplicateIcon style={{height: 18, width: 18}}/>
                                    </Button>
                                    <Button
                                        aria-label={DELETE_BTN.slice(0, -1)}
                                        title={DELETE_BTN.slice(0, -1)}
                                        onClick={(e) => clickDelete(question, e)}
                                    >
                                        <DeleteIcon
                                            style={{
                                                height: 18,
                                                width: 18
                                            }}
                                        />
                                    </Button>


                                </>
                            }
                            {!hasReleased && checkQueImagesIsLoading(question) &&
                                <>
                                    <div style={{width: 16, height: 16}}>
                                        <Skeleton highlightColor="lightgrey"
                                                  width="100%"
                                                  height="100%" borderRadius={4}/>
                                    </div>
                                    <div style={{width: 16, height: 16}}>
                                        <Skeleton highlightColor="lightgrey"
                                                  width="100%"
                                                  height="100%" borderRadius={4}/>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </YuJaTooltip>
        );
    }


    if (!!dataLoading) {
        return (
            <span
                className={classes.questionDashboardContainer}
                style={{display: "unset", border: "none", padding: 0,}}
            >
                <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={8}/>
            </span>
        );
    }

    let questionTabTooltipText = getQuestionTabTooltipText();

    let isQuestionCardsVisible = !!questionBankId
        || (
            pollType !== POLL_TYPE.ATTENDANCE
            && (!questionTabTooltipText || [QUESTION_CARDS_CAN_NOT_ACCESS, QUESTION_CARDS_CAN_NOT_ACCESS_ATTENDANCE, QUESTION_HEADER].includes(questionTabTooltipText))
            && !!questions
        )
    ;

    let isAddQuestionBtnVisible = (
            pollType === POLL_TYPE.MERGED_POLL
            && (!questionTabTooltipText ||  QUESTION_HEADER === questionTabTooltipText)
        )
        || !!questionBankId;

    return (
        <div className={`${classes.questionDashboardContainer} ${isExpanded ? classes.expanded : classes.collapsed}`}>
            {!questionBankId && (isLMS() || draftActivity.pollType !== POLL_TYPE.ATTENDANCE) &&
                <YuJaTooltip
                    placement={"right"}
                    text={draftActivity.pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT}
                    disabled={isExpanded}
                >
                    <Button
                        className={`
                            ${classes.dashboardTab} 
                            ${editorView === ACTIVITY_EDITOR_VIEW.OVERVIEW ? classes.active : ""}
                        `}
                        style={{justifyContent: isExpanded ? "unset" : "center"}}
                        onClick={() =>  setEditorView(ACTIVITY_EDITOR_VIEW.OVERVIEW)}
                    >
                        <span className={classes.dashboardIcon}>
                            <DOCUMENT_ICON/>
                        </span>
                        {isExpanded &&
                            <span className={classes.title} style={{whiteSpace: "nowrap"}}>
                                {draftActivity.pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT}
                            </span>
                        }
                    </Button>
                </YuJaTooltip>
            }

            {!questionBankId &&
                <YuJaTooltip
                    placement={"right"}
                    text={CONFIGURATION_TEXT}
                    disabled={isExpanded}
                >
                    <Button
                        className={`
                            ${classes.dashboardTab} 
                            ${editorView === ACTIVITY_EDITOR_VIEW.CONFIGURATION ? classes.active  : ""}
                        `}
                        style={{justifyContent: isExpanded ? "unset" : "center"}}
                        onClick={() => setEditorView(ACTIVITY_EDITOR_VIEW.CONFIGURATION)}
                    >
                        <span className={`${classes.dashboardIcon} ${editorView === ACTIVITY_EDITOR_VIEW.QUESTION_EDITING ? classes.active : ""}`}>
                            <ConfigurationIcon/>
                        </span>
                        {isExpanded &&
                            <span className={classes.title}>{CONFIGURATION_TEXT}</span>
                        }
                    </Button>
                </YuJaTooltip>
            }




            <YuJaTooltip
                placement={"right"}
                disabled={!questionTabTooltipText}
                text={questionTabTooltipText}
            >
                <Button
                    className={`
                        ${classes.dashboardTab} 
                        ${(!questionTabTooltipText || questionTabTooltipText ===  QUESTION_HEADER) 
                            ? ([ACTIVITY_EDITOR_VIEW.QUESTION_EDITING, ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING].includes(editorView) ? classes.active : "") 
                            : classes.inactive
                        }
                    `}
                    style={{justifyContent: isExpanded ? "unset" : "center"}}
                    onClick={onClickQuestionTab}
                >
                    <span className={`${classes.dashboardIcon} ${editorView === ACTIVITY_EDITOR_VIEW.QUESTION_EDITING ? classes.active : ""}`}>
                        <CHAT_ICON/>
                    </span>
                    {isExpanded &&
                        <span className={classes.title}>{QUESTION_HEADER}</span>
                    }
                </Button>
            </YuJaTooltip>



            {isQuestionCardsVisible &&
                <DragDropContext
                    id={"DragDropContext"}
                    onDragEnd={(result) => {
                        const {destination } = result;
                        if (!destination) {
                            return;
                        }
                        const {index} = destination;
                        const updatedQuestions = handleQuestionOrderChange(result, questions);
                        if (updatedQuestions) {
                            setQuestions(updatedQuestions);
                            setCurrQueDisplay(index + 1);
                        }
                    }}
                >
                    <Droppable droppableId="droppable-sidebar">
                        {(provided, snapshot) => (
                            <div
                                tabIndex={-1}
                                data-activity-editor-list-dashboard-id={randomId}
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                {...provided.dropHandleProps}
                                className={classes.dashboardQuestionList}
                            >
                                {questions.map((question, index) => {
                                    const {serialNo} = question;
                                    return (
                                        <Draggable
                                            key={index}
                                            draggableId={String(serialNo)}
                                            index={index}
                                            isDragDisabled={hasReleased}
                                        >
                                            {(draggableProvided) => renderQuestionCard(draggableProvided, question)}
                                        </Draggable>
                                    );
                                })}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            }


            {isAddQuestionBtnVisible &&
                <YuJaTooltip disabled={isExpanded} text={ADD_QUESTION_TEXT} placement={"right"}>
                    <YuJaButton
                        onClick={clickNewQuestion}
                        style={{
                            flexShrink: 0,
                            width: isExpanded ? 170 : 47,
                            height: 35,
                            display: "flex",
                            alignSelf: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: 10
                        }}
                    >
                        <PlusIcon style={{width: 16, height: 16, marginRight: 2}}/>
                        {isExpanded && ADD_QUESTION_TEXT}
                    </YuJaButton>
                </YuJaTooltip>
            }

            {isAddQuestionBtnVisible &&
                <YuJaTooltip disabled={isExpanded} text={IMPORT_QUESTION_TEXT} placement={"right"}>
                    <YuJaButton
                        onClick={(e) => {
                            e.stopPropagation();
                            setPreviousView(editorView);
                            setEditorView(ACTIVITY_EDITOR_VIEW.IMPORT_QUESTIONS);
                        }}
                        style={{
                            flexShrink: 0,
                            width: isExpanded ? 170 : 47,
                            height: 35,
                            display: "flex",
                            alignSelf: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: 10
                        }}
                    >
                        <UploadIcon style={{width: 16, height: 16, marginRight: 2}}/>
                        {isExpanded && IMPORT_QUESTION_TEXT}
                    </YuJaButton>
                </YuJaTooltip>
            }


        </div>
    );
}